<template>
  <span>
    <v-progress-circular
        v-if="loading"
        size="20"
        color="#409EFF"
        indeterminate
    />
    <v-icon
        :color="value ? color : 'grey'"
        :style="{opacity: value ? 1.0 : 0.1}"
        :aria-checked="value"
        :aria-readonly="true"
        role="checkbox"
    >
      mdi-check
    </v-icon>
  </span>
</template>

<script>
export default {
  name: "ReadonlyCheckbox",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'blue'
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>
